import waitForPortalEventManager from './waitForPortalEventManager';

let eventManagerPromise;

export default async function getPortalEventManager() {
  if (eventManagerPromise === undefined) {
    const portalEventManager = window?.manomano?.portal?.eventManager;

    eventManagerPromise =
      portalEventManager !== undefined
        ? Promise.resolve(portalEventManager)
        : waitForPortalEventManager();
  }
  return eventManagerPromise;
}
